/**
 * Shared logging utilities for consistent formatting across all loggers
 */
export class LogFormatterUtil {
  /**
   * Format context data as a tree structure using Unicode box-drawing characters
   */
  static logContextTree(context: any): void {
    if (!context || typeof context !== 'object') {
      console.log('├─', context);
      return;
    }

    const keys = Object.keys(context);
    keys.forEach((key, index) => {
      const isLast = index === keys.length - 1;
      const prefix = isLast ? '└─' : '├─';
      const value = typeof context[key] === 'object' 
        ? JSON.stringify(context[key], null, 0)
        : context[key];
      console.log(`${prefix} ${key}:`, value);
    });
  }

  /**
   * Generate a short request ID from sessionId
   */
  static getRequestIdFromSession(sessionId: string | undefined, platform: 'server' | 'browser', fallback = 'sys001'): string {
    if (platform === 'browser') {
      return '--';
    }
    
    if (!sessionId) {
      return fallback;
    }
    
    const sessionParts = sessionId.split('_');
    return sessionParts.length > 2 ? sessionParts[2].substring(0, 6) : fallback;
  }

  /**
   * Generate a timestamp-based request ID
   */
  static generateRequestId(): string {
    return Date.now().toString(36).substr(-6);
  }
}